import React, { MouseEvent } from "react"
import { Modal } from "antd"

import clsName from './index.module.scss'
import { unlockForm } from "../../../../../../services/data/data"

interface FormUnlockProps {
  editModel: number
  state: string
  formId: number
  children: React.ReactNode
  onReload: ()=> void
}

const FormUnlock: React.FC<FormUnlockProps> = ({ formId, state, editModel, children, onReload })=> {
  const handleClick = (e: MouseEvent)=> {
    e.stopPropagation()
    if (editModel === 1 && state === 'Complete') {
      Modal.confirm({
        content: '确定解锁此表单？',
        cancelText: '取消',
        okText: '确定',
        onOk: async ()=> {
          await unlockForm(formId)
          onReload()
        }
      })
    }
  }

  if (!children) {
    return null
  }
  
  return (
    <button onClick={handleClick} type="button" className={clsName.wrapper}>
      {children}
    </button>
  )
}

export default FormUnlock